export default "__VITE_ASSET__37fc1b8f__"